<template>
    <div class="files-missing position-relative h-100">
        <h2>{{ hebrew ? 'הקובץ לא קיים' : 'File does not exist' }}</h2>
        <span>{{ hebrew ? 'ייתכן שעבר זמן מאז שהקובץ הועלה לאתר' : 'The files may have expired'}},</span><br>
        <span>{{ hebrew ? 'להעלאת קבצים מחדש, חזור לדף הבית' : 'To restart the process, return to the home page'}}.</span> 
        
        <div class="position-absolute text-center w-100" style="bottom:0">
            <b-button
                to="/"
                variant="primary"
                size="lg"
            >
            {{ hebrew ? 'חזרה לדף הבית' : 'Back to home page' }}
            </b-button>
        </div>
    </div>
</template>
<script>
export default {
    name: "FileMissing",
    data() {
        return {

        }
    },
    computed: {
        hebrew() {
            return this.$settings.hebrew
        }
    }        
}
</script>    